import React, { useState } from 'react';
import { makeStyles } from '@mui/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { findByNome, findByCodigo } from './api-aluno';
import CssBaseline from '@mui/material/CssBaseline';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';
import RadioGroup from '@mui/material/RadioGroup';
import TextField from '@mui/material/TextField';
import { useDispatch, useSelector } from 'react-redux';
import { setAluno, close } from './actions/actions';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';


const useStyles = makeStyles(theme => ({
    table: {
        minWidth: '100%',
    },
    title: {
        marginTop: '10px'
    },
    novoRegistro: {
        marginBottom: '30px'
    },
    cursorLink: {
        cursor: 'pointer'
    },
    formControl: {
        // margin: theme.spacing(3),
    },
    closeIcon: {
        marginTop: '20px',
        cursor: 'pointer'
    }
}));


export default function AlunoFindDialogRedux() {
    const classes = useStyles();
    const [alunos, setAlunos] = useState([]);
    const [opcoesBusca, setOpcoesBusca] = useState({
        por: 'nome',
        busca: ''
    });
    const dispatch = useDispatch();
    const openSearch = useSelector(state => state.openSearch);

    const clickSubmit = () => {
        if (opcoesBusca.por === 'nome') {
            findByNome(opcoesBusca.busca).then((data) => {
                setAlunos(data);
            }).catch((err) => console.log(err));
        } else if (opcoesBusca.por === 'codigo') {
            findByCodigo(opcoesBusca.busca).then((data) => {
                setAlunos(data);
            }).catch((err) => console.log(err));
        }
    }

    const handleBuscaChange = (event) => {
        setOpcoesBusca({
            ...opcoesBusca,
            [event.target.name]: event.target.value
        });

    }

    const handleSelectedAluno = (aluno) => {
        dispatch(setAluno(aluno));
        dispatch(close());
    }

    const handleClose = () => {
        dispatch(close());
    };

    return (
        <div>
            <CssBaseline />

            <Dialog open={openSearch} onClose={handleClose} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Procurar Aluno</DialogTitle>
                <DialogContent>
                    <FormControl component="fieldset" className={classes.formControl}>
                        <FormLabel component="legend">Buscar por:</FormLabel>
                        <RadioGroup aria-label="gender" name="por" value={opcoesBusca.por} onChange={handleBuscaChange}>
                            <FormControlLabel value="codigo" control={<Radio />} label="Código" />
                            <FormControlLabel value="nome" control={<Radio />} label="Nome" />
                        </RadioGroup>
                    </FormControl>
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        label="Busca"
                        name="busca"
                        autoFocus
                        onChange={handleBuscaChange}
                        value={opcoesBusca.busca || ''}
                    />
                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        onClick={clickSubmit}
                        className={classes.submit}>
                        Buscar
                    </Button>
                    <Table className={classes.table} size="small" aria-label="a dense table">
                        <TableHead>
                            <TableRow>
                                <TableCell>Código</TableCell>
                                <TableCell>Nome</TableCell>
                                <TableCell>Ações</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {alunos.map((aluno) => (
                                <TableRow key={aluno.codigo}>
                                    <TableCell>{aluno.codAlunoEscola}</TableCell>
                                    <TableCell>{aluno.nome}</TableCell>
                                    <TableCell>
                                        <Button
                                            onClick={() => handleSelectedAluno(aluno)}
                                            variant="contained"
                                            color="secondary">
                                            Selecionar
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>


                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>

        </div>
    );
}